import type { LiveTradeCancelResponse } from 'apiConnector/secondary-market/live/models';
import { secondaryMarketCancellationActionsFactory } from 'state/secondaryMarket/shared/cancellation/cancellation.actions';

export const liveTradeCancellationActions = secondaryMarketCancellationActionsFactory<LiveTradeCancelResponse, 'LIVE'>(
  'LIVE',
);
type TypeofLiveCancellationActions = typeof liveTradeCancellationActions;
export type SecondaryMarketLiveCancellationWorkflowInit = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancellationWorkflowInit']
>;
export type SecondaryMarketLiveCancellationWorkflowAborted = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancellationWorkflowAborted']
>;
export type SecondaryMarketLiveCancellationWorkflowCompleted = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancellationWorkflowCompleted']
>;
export type SecondaryMarketLiveCancellationRequested = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancellationRequested']
>;
export type SecondaryMarketLiveCancellationReceived = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancelReceived']
>;
export type SecondaryMarketLiveCancellationRejected = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancellationRejected']
>;
export type SecondaryMarketLiveCancellationFailed = ReturnType<
  TypeofLiveCancellationActions['secondaryMarketCancellationFailed']
>;
export type SecondaryMarketLiveCancellationsActions = ReturnType<
  TypeofLiveCancellationActions[keyof TypeofLiveCancellationActions]
>;

export type LiveCancellationActions = typeof liveTradeCancellationActions;
